import { Skeleton } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'

const PostSkeleton: FunctionComponent = () => {
  return (
    <Box>
      <Skeleton.Avatar active shape='square' />
      <Skeleton active paragraph={{ rows: 3, width: 100 }} title={false} />
    </Box>
  )
}

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  .ant-skeleton.ant-skeleton-element {
    .ant-skeleton-avatar {
      height: 178px;
      width: 100%;
      border-radius: 4px 4px 0 0;
    }

    .ant-skeleton-paragraph {
      margin-bottom: 15px;

      > li {
        border-radius: 0;
      }
    }
  }
`

export default PostSkeleton
